<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id"
           :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "TreeChart",
  components: {Chart},
  props: {
    data: null,
    extendData: null,
  },
  data() {
    return {
      id: "treeChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    }
  },
  mounted() {
    this.getOption();
  },
  methods: {
    getOption: function () {
      this.option = {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove'
        },
        series: [{
          zoom: 1, //当前视角的缩放比例
          roam: true, //是否开启平游或缩放
          scaleLimit: { //滚轮缩放的极限控制
            min: 0.5,
            max: 5
          },
          type: 'tree',
          id: 3,
          name: 'tree1',
          data: this.data,

          top: '5%',
          bottom: '10%',

          symbolSize: 20,

          edgeShape: 'curve', //曲线
          edgeForkPosition: '50%',
          initialTreeDepth: 5,

          lineStyle: {
            width: 2,
            color: 'rgba(0, 196, 211,.2)',
          },

          label: this.extendData ?
            {
              color: '#fff',
            } :
            {
              color: '#fff',
              position: 'bottom',
              verticalAlign: 'middle',
              align: 'center',
              distance: 12,
            },

          leaves: this.extendData ? {} : {
            label: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left'
            }
          },

          expandAndCollapse: true,
          animationDuration: 550,
          animationDurationUpdate: 750
        }]
      };
    },
  },
}
</script>

<style scoped>

</style>
